/**
 * @fileoverview BackTop component
 *
 * This component will have a clickable button that will scroll the page back to the top.
 */

import announceNotification from '../../utils/announce-notification';

class BackTop {
	constructor() {
		this.ARIA_LIVE_LABEL_TEXT_ATTR = 'data-announce-text';
		/**
		 * Number of milliseconds to wait between temporarily clearing the label text
		 * in the DOM and subsequently restoring it. This is necessary to force IE 11
		 * to pick up the `aria-live` content change and announce it to the user.
		 */
		this.ARIA_LIVE_DELAY_MS = 1000;

		this.initBackTop()
	}

	initBackTop() {
		const backTopButton = document.querySelector('.js-lta-back-top');
		const announceElement = document.querySelector('.js-announce-notification');

		if (backTopButton !== null) {
			backTopButton.addEventListener('click', () => {
				document.documentElement.scrollTop = 1;
				backTopButton.blur();

				// removes display none to allow the message to be announced
				announceElement.style.display = 'block';

				announceNotification(announceElement, announceElement, this.ARIA_LIVE_LABEL_TEXT_ATTR, this.ARIA_LIVE_DELAY_MS);

				// after announceNotification() ends its work go back to default (display: none)
				setTimeout(() => {
					announceElement.style.display = '';
				}, this.ARIA_LIVE_DELAY_MS + 100);
			});
		}
	}
}

const globalBackTop = new BackTop();

export default globalBackTop;
